module.exports = __webpack_public_path__ + "static/Compute-Software-GDPR-Provisions-Addendum-a55835e9890a0f82fa1bfe9b7d3a4349.pdf";